module.exports = __webpack_public_path__ + "media/src/assets/Images/WhiteLocation-83f8219245cd219647c9753489e88600.svg";